import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {EMPTY_TYPED_VALUE} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {UserTypedValue} from 'notebook/tables/typed-values/TypedValueTypes';
import {EntityWithTextAndSuspended, MinimalEntity} from 'ui-library/entity-input/EntityInputConstants';
import {EntityInputWithSearch} from 'ui-library/entity-input/EntityInputWithSearch';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

type UserTypedValueOrUnassigned = UserTypedValue | typeof EMPTY_TYPED_VALUE;

export interface ProcessTaskAssigneeSearchInputProps {
  value: TypedValue | null;
  onChange: (assignee: UserTypedValueOrUnassigned) => void;
  initialQuery?: string;
}

function entityToTypedValue(entity?: EntityWithTextAndSuspended): UserTypedValueOrUnassigned {
  return entity?.type === ModelTypeConstants.USER
    ? {
        type: BaseTypedValueType.USER,
        id: entity.id,
        userHandle: entity.handle,
        avatarUrl: entity.avatar_url,
        name: entity.name,
      }
    : EMPTY_TYPED_VALUE;
}

/**
 * Input to search and select an assignee (user) for a process task.
 */
export default function ProcessTaskAssigneeSearchInput(
  props: ProcessTaskAssigneeSearchInputProps
): JSX.Element {
  const minimalEntity: MinimalEntity | null =
    props.value?.type === BaseTypedValueType.USER
      ? {id: props.value.id, handle: props.value.userHandle}
      : null;

  return (
    <EntityInputWithSearch
      onChange={(assigneeArray: Array<EntityWithTextAndSuspended>) => {
        props.onChange(entityToTypedValue(assigneeArray[0]));
      }}
      enableNewEntityInput={true}
      allowEmails={true}
      allowTeams={false}
      allowOrganizations={false}
      placeholder="Search for user"
      emptyText="No results found."
      initialQuery={props.initialQuery}
      shouldAllowMultiple={false}
      value={minimalEntity ? [minimalEntity] : []}
      size={TagsInputSize.SMALL}
    />
  );
}
